import { Route, Routes } from "react-router-dom";
import TreatzSpa from "@src/pages/treatzSpa";

const TreatzSpaRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<TreatzSpa />} />
    </Routes>
  );
};

export default TreatzSpaRoute;
